const NotFound = () => {
  return (
    <div className='h-100 w-100 d-flex justify-content-center align-items-center'>
      <h1>PAGE NOT FOUND!</h1>
    </div>
  );
};

export default NotFound;
